import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

import tt from '../../img/CompositeMesh/tt.webp'

function Physical () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("CompositeReinforcement.15")}</Trans>
                    </p>
                </div>
                <div className='xl:mt-[65px] flex flex-col relative'>
                <Fade delay={1300}><img src={tt} alt="" className='xl:absolute mt-[45px] xl:mt-0 xl:py-0 px-[50px] sm:px-[150px] md:px-[250px] xl:px-0 left-1/2 xl:!-translate-x-1/2 top-[120px] object-cover w-full h-full xl:w-auto xl:h-auto'/></Fade>
                    <div className='hidden xl:flex justify-between xl:justify-normal'>
                        <Fade left delay={200}><div className='sm:mx-auto flex flex-col items-start'>
                            <div className='max-w-[334px] ml-[25px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.1')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.2')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade right delay={400}><div className='sm:mx-auto flex flex-col items-end'>
                            <div className='max-w-[334px] mr-[25px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.3')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.4')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[125px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                    <div className='hidden xl:flex justify-between xl:mt-[40px]'>
                        <Fade left delay={600}><div className='flex flex-col items-start'>
                            <div className='max-w-[334px] ml-[25px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.5')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.6')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[150px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade right delay={800}><div className='flex flex-col items-end'>
                            <div className='max-w-[334px] mr-[25px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.7')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.8')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[140px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                    <div className='hidden xl:flex justify-between xl:justify-normal mt-[40px]'>
                        <Fade left delay={200}><div className='sm:mx-auto flex flex-col items-start'>
                            <div className='max-w-[334px] ml-[25px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.9')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.10')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade right delay={400}><div className='sm:mx-auto flex flex-col items-end'>
                            <div className='max-w-[334px] mr-[25px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.11')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.12')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[125px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                </div>
                <div className='xl:hidden grid grid-cols-2 mt-[30px] gap-x-[20px] gap-y-[10px]'>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.1')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.2')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.3')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.4')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.5')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.6')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.7')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.8')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.9')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.10')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('ppp.11')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('ppp.12')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                </div>
            </div>
        </div>
    );
}

export default Physical;